import * as React from 'react';

/**
 * @ignore - internal component.
 */
const Tablelvl2Context = /*#__PURE__*/React.createContext();
if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}
export default Tablelvl2Context;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Table/Tablelvl2Context.js
// module id = 202
// module chunks = 22